import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, eur } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PrintOrder() {
  const { orderId } = useParams();
  const [o, setO] = useState(null);

  useEffect(() => {
    api.get(`/staff/orders/${orderId}`).then((r) => {
      setO(r.data);
      api.post(`/staff/orders/${orderId}/print`).catch(() => {});
      setTimeout(() => window.print(), 500);
    });
  }, [orderId]);

  if (!o) return <div className="p-8">Caricamento…</div>;

  return (
    <div className="p-4 bg-white">
      <div className="no-print mb-3 flex gap-2">
        <Button onClick={() => window.print()} data-testid="reprint-btn">Stampa</Button>
        <Button variant="outline" onClick={() => window.close()}>Chiudi</Button>
      </div>
      <div className="print-ticket max-w-[300px]">
        <div className="text-center">
          <div style={{ fontSize: 20, fontWeight: 700 }}>SARABI BEACH</div>
          <div style={{ fontSize: 12 }}>Comanda #{o.code}</div>
          <div style={{ fontSize: 11 }}>{new Date(o.created_at).toLocaleString("it-IT")}</div>
        </div>
        <hr style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
        <div style={{ fontSize: 22, fontWeight: 700, textAlign: "center" }}>{o.station_name}</div>
        <div style={{ fontSize: 12, textAlign: "center" }}>Cliente: {o.customer_name}</div>
        <div style={{ fontSize: 11, textAlign: "center" }}>{o.customer_phone}</div>
        <hr style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
        {o.items.map((i, idx) => (
          <div key={idx} style={{ marginBottom: 6 }}>
            <div style={{ fontWeight: 700, fontSize: 14 }}>{i.quantity}× {i.product_name}</div>
            {i.modifiers?.map((m, k) => <div key={k} style={{ fontSize: 11 }}>  · {m.option_name}</div>)}
            {i.note && <div style={{ fontSize: 11, fontStyle: "italic" }}>  Nota: {i.note}</div>}
            {i.allergens?.length > 0 && <div style={{ fontSize: 11 }}>  Allergeni: {i.allergens.join(", ")}</div>}
          </div>
        ))}
        <hr style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
          <span>Subtotale</span><span>{eur(o.subtotal_cents)}</span>
        </div>
        {o.service_charge_cents > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
            <span>Servizio</span><span>{eur(o.service_charge_cents)}</span>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 16, fontWeight: 700 }}>
          <span>TOTALE</span><span>{eur(o.total_cents)}</span>
        </div>
        <div style={{ fontSize: 11, marginTop: 4 }}>Pagamento: {o.payment_method} ({o.payment_status})</div>
        <hr style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
        {o.print_count > 0 && <div style={{ textAlign: "center", fontWeight: 700 }}>*** COPIA ({o.print_count + 1}) ***</div>}
        <div style={{ textAlign: "center", fontSize: 11, marginTop: 6 }}>Grazie e buon divertimento</div>
      </div>
    </div>
  );
}
